<div class="form-container">
  <form class="setup-phone-form" (ngSubmit)="setupPhone()" #setupPhoneForm="ngForm" novalidate>
    <app-logo-link></app-logo-link>
    <p class="message">
      Add a phone for two-factor authentication
    </p>
    <p>
      We'll use this phone to verify logins from new devices and browsers.
    </p>
    <div class="container">
      <div matPrefix class="flex-row">
      <mat-form-field class="country-code-input">
        <mat-select name="countryCode" [(ngModel)]="loginStateService.countryCode" [panelClass]="'dashboard-select-panel'" [panelWidth]=null (selectionChange)="onCountryCodeChange($event)">
          <mat-select-trigger>
            {{ loginStateService.countryCode.selected_label }}
          </mat-select-trigger>
          <mat-option *ngFor="let option of countryCodes" [value]="option">
            {{ option.option_label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="phone-number-input">
        <input matInput #phoneNumber="ngModel" name="phoneNumber" type="text" required pattern="^([\-\s\.])?((\(\d{1,4}\))|\d{1,4})(([\-\s\.])?[0-9]{1,12}){1,2}$" placeholder="Phone Number" [(ngModel)]="loginStateService.phoneNumber">
      </mat-form-field>
      </div>
      @if (phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)) {
        <div class="error-message">
          Please enter a valid phone number.
        </div>
      }
      @if(!doesCountryCodeAllowVoice()) {
        <div class="mat-hint">
          Selected country code only allows for text messages.
        </div>
      }
      <div>
        <mat-radio-group name="sendMethod" [(ngModel)]="loginStateService.sendMethod" [disabled]="!this.doesCountryCodeAllowVoice()">
          <mat-radio-button value="sms">
            Text Me
          </mat-radio-button>
          <mat-radio-button value="call">
            Call Me
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <button color="primary" type="submit" mat-raised-button [disabled]="!setupPhoneForm.valid || setupPhoneForm.pristine">
      Send Code
    </button>
  </form>
</div>
